module.exports = __webpack_public_path__ + "static/media/colheitadeira.70e38cfb.svg";